import KAM001V1 from '@/views/kam/forms/KAM001-v1.vue'
import KAM001V2 from '@/views/kam/forms/KAM001-v2.vue'
import KAM002V1 from '@/views/kam/forms/KAM002-v1.vue'
import KAM002V2 from '@/views/kam/forms/KAM002-v2.vue'
import KAM003V1 from '@/views/kam/forms/KAM003-v1.vue'
import KAM003V2 from '@/views/kam/forms/KAM003-v2.vue'
import KAM004V1 from '@/views/kam/forms/KAM004-v1.vue'
import KAM005V1 from '@/views/kam/forms/KAM005-v1.vue'

export type KamFormRegistryEntry = {
  id: number
  reference: string
  name: string
  version: number
  component: any
  nameWithVersion: string
}

export const formsRaw: KamFormRegistryEntry[] = [
  { id: 1, reference: 'KAM001', name: 'Incidenten Rapport', version: 1, component: KAM001V1, nameWithVersion: 'Incidenten Rapport' },
  { id: 2, reference: 'KAM002', name: 'VGM Deelplan', version: 1, component: KAM002V1, nameWithVersion: 'VGM Deelplan' },
  { id: 3, reference: 'KAM003', name: 'Startgesprek', version: 1, component: KAM003V1, nameWithVersion: 'Startgesprek' },
  { id: 4, reference: 'KAM001', name: 'Incidenten Rapport', version: 2, component: KAM001V2, nameWithVersion: 'Incidenten Rapport' },
  { id: 5, reference: 'KAM004', name: 'Beoordeling VGM-beheersing Projecten', version: 1, component: KAM004V1, nameWithVersion: 'Beoordeling VGM-beheersing Projecten' },
  { id: 7, reference: 'KAM005', name: 'VGM-plan', version: 1, component: KAM005V1, nameWithVersion: 'VGM-plan' },
  { id: 8, reference: 'KAM003', name: 'Startgesprek', version: 2, component: KAM003V2, nameWithVersion: 'Startgesprek' },
  { id: 2, reference: 'KAM002', name: 'VGM Deelplan', version: 2, component: KAM002V2, nameWithVersion: 'VGM Deelplan' }
]

export const forms: KamFormRegistryEntry[] = (() => {
  const latestMap = new Map<string, KamFormRegistryEntry>()
  formsRaw.forEach((form) => {
    const existing = latestMap.get(form.reference)
    if (!existing || form.version > existing.version || (form.version === existing.version && form.id > existing.id)) {
      latestMap.set(form.reference, form)
    }
  })
  return Array.from(latestMap.values()).sort((a, b) => a.reference.localeCompare(b.reference))
})()

export function getKamFormById (id: number|null|undefined): KamFormRegistryEntry|undefined {
  if (id == null) return undefined
  return formsRaw.find(form => form.id === id)
}

export function getKamFormByReference (reference: string|undefined|null, version: number|undefined|null): KamFormRegistryEntry|undefined {
  if (!reference || version == null) return undefined
  return formsRaw.find(form => form.reference === reference && form.version === version)
}

export function getKamFormByReferenceLatest (reference: string|undefined|null): KamFormRegistryEntry|undefined {
  if (!reference) return undefined
  return forms.find(form => form.reference === reference)
}
